<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     成员列表
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="fam-member-list">

    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item" style="width: 120px;">
          <el-select v-model="query.default_auth" placeholder="权限" clearable @change="fetchData(1)">
            <el-option v-for="auth in auths" :key="auth.value" :label="auth.title" :value="auth.value" />
          </el-select>
        </div>
        <div class="filter-item" style="width: 120px;">
          <el-select v-model="query.status" placeholder="状态" clearable @change="fetchData(1)">
            <el-option v-for="item in status" :key="item.value" :label="item.title" :value="item.value" />
          </el-select>
        </div>
        <div class="filter-item" style="width: 160px;">
          <el-input v-model="query.keyword" placeholder="昵称 / 备注名" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
        </div>
      </div>

      <div class="toolbox">
        <el-button icon="el-icon-plus" type="success" @click="onPostFormShow()">新成员</el-button>
      </div>
    </div>

    <el-card shadow="never" class="mb-md">
      <el-table ref="listTable" v-loading="loading" :data="list" style="width: 100%">
        <el-table-column type="index" label="#" width="80" align="center" />
        <el-table-column width="60">
          <template slot-scope="scope">
            <f-user-avatar :src="scope.row.avatar" />
          </template>
        </el-table-column>
        <el-table-column label="呢称" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <f-user-name :user="scope.row" />
          </template>
        </el-table-column>
        <el-table-column label="备注名" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.remark }}
          </template>
        </el-table-column>
        <el-table-column label="权限" min-width="80">
          <template slot-scope="scope">
            {{ authObj[scope.row.default_auth].title }}
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" prop="allow_bind_sum" label="允许绑定数量" min-width="120" /> -->
        <el-table-column label="自动绑定" min-width="80">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.auto_bind" active-color="#07c160" :active-value="1" :inactive-value="0" @change="handleAutoBind(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" type="success">已确认</el-tag>
            <el-tag v-if="scope.row.status === 2" type="warning">待确认</el-tag>
            <el-tag v-if="scope.row.status === 3" type="danger">已拒绝</el-tag>
            <el-button v-if="scope.row.status !== 1" type="text" class="span re-notice" @click="reNotice(scope.row)">重发</el-button>
          </template>
        </el-table-column>
        <el-table-column label="邀请时间" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.updatetime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="onPostFormShow(scope.row)">编辑</el-button>
            <el-button type="text" @click="onDeleteRelater(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
            </template>
          </f-table-footer>
        </template>
        <template slot="empty">
          <div class="font-md mt-hg">
            暂无数据
          </div>
          <el-button plain size="small" type="warning" @click="onPostFormShow">邀请成员</el-button>
        </template>
      </el-table>
    </el-card>

    <el-dialog width="600px" :title="(formData.memberid ? '编辑' : '邀请') + '成员'" :visible.sync="dialogShow" :modal-append-to-body="false" @closed="onClose">

      <el-alert v-if="!formData.memberid" title="邀请新成员时，被邀用户会收到微信邀请通知，用户同意后，即可成为企业成员！" type="warning" class="mb-lg" :closable="false" style="margin-top: -15px;">
      </el-alert>

      <el-form ref="postForm" v-loading="posting" label-position="left" label-width="120px" style="padding: 0 30px" :model="formData" :rules="formRules">
        <el-form-item v-if="!formData.nickname" label="昵称" prop="relater">
          <el-select v-model="formData.relater" placeholder="请输入用户昵称搜索" :clearable="true" autocomplete="off" filterable remote :remote-method="remoteMethod" style="width: 100%;" @change="onSelectChange">
            <el-option v-for="item in options" :key="item.memberid" :value="item.memberid" :label="item.nickname" :disabled="item.is_relater ? true : false" class="member-op">
              <div class="flex">
                <f-user-avatar class="ft" :src="item.avatar" size="mini" :preview="false" />
                <span class="ml bd" :class="{ 'text-success': item.is_relater }">{{ item.nickname }}</span>
                <span v-if="item.is_relater" class="ft text-success">{{ '已绑定' }}</span>
              </div>
            </el-option>
          </el-select>
          <!-- <span class="text-muted">请确保该粉丝已关注公众号</span> -->
        </el-form-item>

        <el-form-item v-else label="昵称">
          <span>{{ formData.nickname }}</span>
        </el-form-item>

        <el-form-item label="备注名">
          <el-input v-model="formData.remark" placeholder="请填写备注名" />
        </el-form-item>

        <el-form-item label="权限" prop="default_auth">
          <el-select v-model="formData.default_auth" :clearable="true" placeholder="选择权限" style="width: 100%;">
            <el-option v-for="item in auths" :key="item.value" :label="item.title" :value="item.value" />
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="允许绑定数量" prop="allow_bind_sum">
          <el-input-number v-model="formData.allow_bind_sum" size="mini" :precision="0" :min="1" :max="9999" />
        </el-form-item> -->

        <el-form-item label="自动绑定" prop="auto_bind">
          <el-switch v-model="formData.auto_bind" active-color="#07c160" :active-value="1" :inactive-value="0" />
          <span class="ml-xs text-muted">{{ '开启后，新设备将自动绑定，无需成员再扫码' }}</span>
        </el-form-item>
      </el-form>

      <div slot="footer" class="flex-center mb">
        <el-button class="extend" @click="dialogShow = false">取消</el-button>
        <el-button class="extend" type="primary" @click="onPostFormSubmit">{{ formData.memberid ? '确定' : '邀请' }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { noticeApi, relaterListApi, wechatFanGetfewApi, postRelaterApi, delRelaterApi } from '@/api/fam/famMemberApi'

export default {
  name: 'FamMemberList',


  data () {
    return {
      memberid: 0,
      show_detail: false,
      loading: false,
      posting: false,
      selectLoading: false,
      maxBindNum: 9999,
      list: [],
      total: 0,
      dialogShow: false,
      options: [],
      query: {
        default_auth: null,
        status: null,
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        keyword: ''
      },
      status: [
        { value: 1, title: '已确认' },
        { value: 0, title: '待确认' }
      ],
      auths: [],
      authObj: {},
      formData: {
        nickname: '',
        remark: '',
        relater: null,
        default_auth: null,
        allow_bind_sum: 100,
        auto_bind: 1
      },
      formRules: {
        relater: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        default_auth: [
          { required: true, message: '权限不能为空', trigger: 'blur' }
        ]
      }
    }
  },

  computed: {
    currentRelaterNum () {
      return this.list.length
    }
  },

  created () {
    this.auths = this.$store.state.rmsStore.authArr.slice(0, 5)
    if (this.$store.state.userStore.is_frippler) {
      this.auths.push({ value: 10, title: '鱼漾', style: 'text-success' })
    }
    this.authObj = Object.assign({}, this.$store.getters.authObj)
    this.fetchData()
    this.resetFormData()
  },

  methods: {
    resetFormData () {
      this.formData = {
        memberid: null,
        default_auth: null,
        allow_bind_sum: 100,
        auto_bind: 1,
        remark: ''
      }
    },

    fetchData () {
      this.loading = true
      relaterListApi(this.query).then(res => {
        this.loading = false
        if (!res.errno) {
          this.list = res.data.list
          this.total = res.data.total
          this.maxBindNum = res.data.allow_bind_sum_max
        }
      })
    },

    handleAutoBind (row) {
      const temp = {
        memberid: row.memberid,
        default_auth: row.default_auth,
        allow_bind_sum: row.allow_bind_sum,
        auto_bind: row.auto_bind,
        remark: row.remark
      }
      postRelaterApi(temp).then(res => {
        if (res.errno === 0) {
          this.$message({
            type: 'success',
            message: '设置成功'
          })
        } else {
          row.auto_bind = row.auto_bind ? 0 : 1
          this.$message({
            type: 'warning',
            message: res.message
          })
        }
      }).catch(() => {
      })
    },

    onDeleteRelater (row) {
      this.$confirm('即将删除成员「' + row.nickname + '」，是否继续？', '操作确认', {
        type: 'error'
      }).then(() => {
        const array = Array.of(row.memberid)
        delRelaterApi({ memberids: array }).then(res => {
          if (!res.errno) {
            this.fetchData()
            this.$message.success('成员删除成功！')
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },

    onPostFormShow (row = {}) {
      this.resetFormData()
      if (row.memberid) {
        Object.assign(this.formData, row)
      }
      this.dialogShow = true
      this.$nextTick(() => {
        this.$refs['postForm'].clearValidate()
      })
    },

    onClose () {
      this.options = []
    },

    onPostFormSubmit () {
      this.$refs['postForm'].validate((valid) => {
        if (valid) {
          this.posting = true
          const temp = {
            memberid: this.formData.memberid ? this.formData.memberid : this.formData.relater,
            default_auth: this.formData.default_auth,
            allow_bind_sum: this.formData.allow_bind_sum,
            auto_bind: this.formData.auto_bind,
            remark: this.formData.remark
          }
          postRelaterApi(temp).then(res => {
            if (!res.errno) {
              this.posting = false
              this.fetchData()
              this.dialogShow = false
              this.$message.success(res.message)
            } else {
              this.posting = false
              this.$message.error(res.message)
            }
          })
        }
      })
    },

    remoteMethod (query) {
      if (query !== '') {
        this.options = []
        this.selectLoading = true
        wechatFanGetfewApi({ 'keyword': query, 'num': 3 }).then(res => {
          if (!res.errno) {
            this.options = res.data.list
            this.selectLoading = false
          } else {
            this.$message.error(res.message)
          }
        }).catch(() => {
        })
      } else {
        this.options = []
      }
    },

    reNotice (row) {
      this.$confirm('再次向 ' + row.nickname + ' 发送一条成员邀请通知，是否继续？', {
        type: 'warning'
      }).then(() => {
        noticeApi({ memberid: row.memberid }).then(res => {
          if (!res.errno) {
            this.fetchData()
            this.$message.success('发送成功')
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
      })
    },

    onSelectChange (val) {
      if (!this.formData.relater) {
        this.options = []
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.fam-member-list {
  .el-table {
    .name {
      vertical-align: top;
    }
  }
  .re-notice {
    text-decoration: underline;
    color: #606266;
  }

}
</style>
<style lang="scss">
.fam-member-list {
  .el-link {
    display: revert;
  }
}
</style>
